import { CRUD } from 'src/store/models/helper/CRUD.js'
import GlobalPrototypes from '@/config/services/globalPrototypes.ts'
import Timetable from 'src/api/timetable.js'
import Users from 'src/api/users.js'
// TODO stop importing the mixin!
import schoolYearMixin from '@/mixins/management/schoolYearMixin.js'

export class TimetableMeta extends CRUD {
  static entity = 'timetable_meta'
  static fetchUrl = (id) => Users.newsFeedCommentsUrl(id)

  static fields () {
    const suggestedSchoolYear = schoolYearMixin.computed.suggestSchoolYearRangePrototype()
    return {
      id: this.attr(null),
      school_id: this.attr(null),
      begins_at: this.attr(GlobalPrototypes.moment(suggestedSchoolYear.begins_at).toDate().toJSON()),
      ends_at: this.attr(GlobalPrototypes.moment(suggestedSchoolYear.ends_at).toDate().toJSON()),
      calendar_view: this.boolean(false),
      days_to_show: this.number(5),
      name: this.string(null).nullable()
    }
  }

  static mutators () {
    const suggestedSchoolYear = schoolYearMixin.computed.suggestSchoolYearRangePrototype()
    return {
      begins_at (value) {
        if (!GlobalPrototypes.moment(value).isValid()) return GlobalPrototypes.moment(suggestedSchoolYear.begins_at).toDate().toJSON()
        return GlobalPrototypes.moment(value).toDate().toJSON()
      },
      ends_at (value) {
        if (!GlobalPrototypes.moment(value).isValid()) return GlobalPrototypes.moment(suggestedSchoolYear.ends_at).toDate().toJSON()
        return GlobalPrototypes.moment(value).toDate().toJSON()
      }
    }
  }

  static relations = []

  static async publishTimetable ({ showMessages } = { showMessages: true }) {
    return Timetable.postTimetableEditorPublish({}, { headers: this.store().state.timetablePlanner.headers, showMessages })
  }

  getProjectName () {
    return this.name || `${GlobalPrototypes.dateFormat.yearlong(this.begins_at)} / ${GlobalPrototypes.dateFormat.yearlong(this.ends_at)}`
  }
}

export default TimetableMeta
